export const certificationsData = [
  {
    id: 1,
    name: "Information Technology Specialist In Javascript",
    provider: "Pearson Vue (Certiport)",
    timeline: "19/12/2022",
    certificateLink:
      "./assets/certifications/IT Specialist Certificate - Certiport.pdf",
    link: "https://certiport.pearsonvue.com/Certifications/ITSpecialist/Certification/Certify",
  },
  {
    id: 2,
    name: "Javascript And Front-End Frameworks",
    provider: "New Horizons",
    timeline: "18/11/2022",
    certificateLink: "./assets/certifications/New Horizon Certificate.pdf",
    link: "https://ict.gov.ge/trainings/javascript-and-front-end-frameworks/",
  },
];
